import React from 'react';
import SubnavMobileStyled from '../../../_atoms/SubnavMobileStyled';
import SubnavItem from '@molecules/SubnavItem';

const PropertiesMobileSubnav = () => (
    <SubnavMobileStyled>
        <SubnavItem label="Find Properties" to="/my-icsc/properties/find" exact={false} />
        <SubnavItem label="Saved Properties" to="/my-icsc/properties/saved" />
        <SubnavItem label="Listed Properties" to="/my-icsc/properties/listed" />
    </SubnavMobileStyled>
);

export default PropertiesMobileSubnav;
